import { useParsedCohortQueryParam } from 'components/hooks/useParsedCohortQueryParam';
import { useLocation } from 'react-router-dom';

import { routes } from 'constants/routes';

const STATIC_ROUTES = [
  {
    name: 'Performance Review',
    route: routes.performanceReview.index,
  },
  {
    name: 'My Development Plan',
    route: routes.levelUp.index,
  },
  {
    name: 'Develop My Team',
    route: routes.levelUp.myTeam,
  },
  {
    name: 'Develop My Team Insights',
    route: routes.levelUp.myTeamInsights,
  },
  {
    name: 'My Feedback',
    route: routes.continuousFeedback.index,
  },
];

export const useViewPageName = () => {
  const location = useLocation();

  const queryParams = useParsedCohortQueryParam();
  const { name: cohortName = '', id: cohortId } = queryParams ?? {};

  if ([0, -1, -2, -3, -4, -5, -6, -7, -8, -9, -10].includes(cohortId)) {
    return cohortName;
  }

  if (STATIC_ROUTES.find((r) => r.route === location.pathname)) {
    return STATIC_ROUTES.find((r) => r.route === location.pathname).name;
  }

  return cohortName;
};
